import { Route, Routes } from 'react-router-dom';
import { MainLayout } from 'shared/components/layout/MainLayout';
import { ProtectedRoute } from 'shared/components/ProtectedRoute';
import { ROUTES } from 'shared/constants/routes';
import { HomePage } from 'modules/jogador/home/HomePage';
import { LoginPage } from 'modules/jogador/auth/LoginPage';
import { SignupPage } from 'modules/jogador/auth/SignupPage';
import { ProfilePage } from 'modules/jogador/profile/ProfilePage';
import { MyAgendaPage } from 'modules/jogador/agenda/MyAgendaPage';
import { BookingPage } from 'modules/jogador/booking/BookingPage';
import { CheckoutPage } from 'modules/jogador/checkout/CheckoutPage';
import { ClassesPage } from 'modules/jogador/classes/ClassesPage';
import { TournamentsListPage } from 'modules/jogador/tournaments/TournamentsListPage';
import { TournamentDetailPage } from 'modules/jogador/tournaments/TournamentDetailPage';
import { MuralPage } from 'modules/jogador/mural/MuralPage';
import { ArenaOnboardingPage } from 'modules/arena/onboarding/ArenaOnboardingPage';
import { ArenaDashboardPage } from 'modules/arena/dashboard/ArenaDashboardPage';
import { ArenaSettingsPage } from 'modules/arena/settings/ArenaSettingsPage';
import { ArenaReportsPage } from 'modules/arena/reports/ArenaReportsPage';
import { ArenaReservationsPage } from 'modules/arena/reservations/ArenaReservationsPage';
import { ArenaClassGroupsPage } from 'modules/arena/class-groups/ArenaClassGroupsPage';
import { ArenaTournamentsPage } from 'modules/arena/tournaments/ArenaTournamentsPage';
import { ArenaMuralPage } from 'modules/arena/mural/ArenaMuralPage';
import { ArenaSubscriptionsPage } from 'modules/arena/subscriptions/ArenaSubscriptionsPage';
import { AdminDashboardPage } from 'modules/admin/dashboard/AdminDashboardPage';
import { InstructorClassesPage } from 'modules/instrutor/classes/InstructorClassesPage';
import { RecepcaoReservationsPage } from 'modules/recepcao/reservations/RecepcaoReservationsPage';
import { NotFoundPage } from 'shared/pages/NotFoundPage';
import { ArenaLayout } from 'modules/arena/shared/ArenaLayout';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.SIGNUP} element={<SignupPage />} />
        <Route path={ROUTES.ARENA_ONBOARDING} element={<ArenaOnboardingPage />} />

        <Route element={<ProtectedRoute />}>
          <Route path={ROUTES.PROFILE} element={<ProfilePage />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['jogador']} />}>
          <Route path={ROUTES.MY_AGENDA} element={<MyAgendaPage />} />
          <Route path={ROUTES.BOOKING} element={<BookingPage />} />
          <Route path={ROUTES.CHECKOUT} element={<CheckoutPage />} />
          <Route path={ROUTES.CLASSES} element={<ClassesPage />} />
          <Route path={ROUTES.TOURNAMENTS} element={<TournamentsListPage />} />
          <Route path={ROUTES.TOURNAMENT_DETAIL} element={<TournamentDetailPage />} />
          <Route path={ROUTES.MURAL} element={<MuralPage />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['arena']} />}>
          <Route element={<ArenaLayout />}>
            <Route path={ROUTES.ARENA_DASHBOARD} element={<ArenaDashboardPage />} />
            <Route path={ROUTES.ARENA_RESERVATIONS} element={<ArenaReservationsPage />} />
            <Route path={ROUTES.ARENA_CLASSES} element={<ArenaClassGroupsPage />} />
            <Route path={ROUTES.ARENA_TOURNAMENTS} element={<ArenaTournamentsPage />} />
            <Route path={ROUTES.ARENA_MURAL} element={<ArenaMuralPage />} />
            <Route path={ROUTES.ARENA_SUBSCRIPTIONS} element={<ArenaSubscriptionsPage />} />
            <Route path={ROUTES.ARENA_SETTINGS} element={<ArenaSettingsPage />} />
            <Route path={ROUTES.ARENA_REPORTS} element={<ArenaReportsPage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route path={ROUTES.ADMIN_DASHBOARD} element={<AdminDashboardPage />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['instrutor']} />}>
          <Route path={ROUTES.INSTRUCTOR_CLASSES} element={<InstructorClassesPage />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['recepcao']} />}>
          <Route path={ROUTES.RECEPCAO_RESERVATIONS} element={<RecepcaoReservationsPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
